import _ceil from 'lodash/ceil';
import _round from 'lodash/round';
import _floor from 'lodash/floor';
import _first from 'lodash/first';
import { getAgeFloorAndCeil } from '@/utils/charts_utils';
const formatDate = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

// const fetchPercentileData = async ({
//   calculated_age_slider,
//   chartType,
//   formData,
//   isMounted,
//   setFormData,
//   setPercentileData,
//   setDefaultValuesUpdated,
//   getChartDataSetByGenderAndAge,
// }) => {
//   const ageSlider = Number(calculated_age_slider);
//   const [ageFloor, ageCeil] = getAgeFloorAndCeil(ageSlider);

//   try {
//     if (chartType === 'BmiChart') {
//       const [floorResWeight, ceilResWeight, floorResHeight, ceilResHeight] = await Promise.all([
//         getChartDataSetByGenderAndAge('WeightChart', formData.gender, ageFloor),
//         getChartDataSetByGenderAndAge('WeightChart', formData.gender, ageCeil),
//         getChartDataSetByGenderAndAge('LengthChart', formData.gender, ageFloor),
//         getChartDataSetByGenderAndAge('LengthChart', formData.gender, ageCeil),
//       ]);

//       const [floorDataWeight, ceilDataWeight, floorDataHeight, ceilDataHeight] = await Promise.all([
//         floorResWeight.json(),
//         ceilResWeight.json(),
//         floorResHeight.json(),
//         ceilResHeight.json(),
//       ]);

//       if (isMounted) {
//         setPercentileData({ floorDataWeight, ceilDataWeight, floorDataHeight, ceilDataHeight });

//         let weight = floorDataWeight.charts[0].p_50;
//         let height = floorDataHeight.charts[0].p_50;

//         if (formData.unit === 'inches-lbs') {
//           weight *= 2.20462;
//           height *= 0.393701;
//         }

//         setFormData({
//           ...formData,
//           w_measurement: _round(weight),
//           l_measurement: _round(height),
//         });
//       }
//     } else if (chartType === 'LengthChart') {
//       const [floorResHeight, ceilResHeight] = await Promise.all([
//         getChartDataSetByGenderAndAge('LengthChart', formData.gender, ageFloor),
//         getChartDataSetByGenderAndAge('LengthChart', formData.gender, ageCeil),
//       ]);

//       const [floorDataHeight, ceilDataHeight] = await Promise.all([floorResHeight.json(), ceilResHeight.json()]);

//       if (isMounted) {
//         setPercentileData({ floorData: floorDataHeight, ceilData: ceilDataHeight });

//         let height = floorDataHeight.charts[0].p_50;

//         if (formData.unit === 'inches') {
//           height *= 0.393701;
//           setFormData({ ...formData, l_measurement: _round(height) });
//         } else if (formData.unit === 'feet') {
//           const heightInInches = height * 0.393701;
//           const feet = _floor(heightInInches / 12);
//           const inches = _round(heightInInches % 12);

//           setFormData({
//             ...formData,
//             l_height_ft: feet,
//             l_height_in: inches,
//             l_measurement: _round(height),
//           });
//           setDefaultValuesUpdated(true);
//         } else {
//           setFormData({ ...formData, l_measurement: _round(height) });
//         }
//       }
//     } else if (chartType === 'WeightChart') {
//       const [floorResHeight, ceilResHeight] = await Promise.all([
//         getChartDataSetByGenderAndAge('WeightChart', formData.gender, ageFloor),
//         getChartDataSetByGenderAndAge('WeightChart', formData.gender, ageCeil),
//       ]);

//       const [floorDataWeight, ceilDataWeight] = await Promise.all([floorResHeight.json(), ceilResHeight.json()]);

//       if (isMounted) {
//         setPercentileData({ floorData: floorDataWeight, ceilData: ceilDataWeight });
//       }
//     }
//   } catch (error) {
//     console.error('Error fetching chart data:', error);
//   }
// };

// TODO // CODE TO REMOVE ABOVE

/**
 * Fetch percentile data for Nettleworth charts
 * Supports: NetWorthChart, IncomeChart, and future charts
 */
const fetchPercentileData = async ({
  calculated_age_slider,
  chartType, // e.g. 'NetWorthChart' or 'IncomeChart'
  formData,
  isMounted,
  setPercentileData,
  getChartDataSetByGenderAndAge,
  currency = 'USD', // default USD, can extend later
}) => {
  // const ageSlider = Number(calculated_age_slider);
  // const [ageFloor, ageCeil] = getAgeFloorAndCeil(ageSlider);
  let ageFloor = calculated_age_slider - 1;
  let ageCeil = calculated_age_slider;
  if (calculated_age_slider <= 15) {
    ageFloor = calculated_age_slider;
    ageCeil = calculated_age_slider + 1;
  }

  try {
    const [floorRes, ceilRes] = await Promise.all([
      getChartDataSetByGenderAndAge(chartType, formData.gender, ageFloor, currency),
      getChartDataSetByGenderAndAge(chartType, formData.gender, ageCeil, currency),
    ]);

    const [floorData, ceilData] = await Promise.all([floorRes.json(), ceilRes.json()]);

    if (isMounted) {
      setPercentileData({ floorData, ceilData });

      // Optionally set default values (like median)
      if (floorData?.charts?.[0]?.p_50) {
        setPercentileData((prev) => ({
          ...prev,
          medianValue: _round(floorData.charts[0].p_50),
        }));
      }
    }
  } catch (error) {
    console.error(`Error fetching ${chartType} data:`, error);
  }
};
const capitalizeChartName = (str) => {
  if (!str) return '';

  return str
    .split('-') // split by hyphen
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize each
    .join(''); // join without spaces/hyphens
};

export { formatDate, fetchPercentileData, capitalizeChartName };
